module.exports = __webpack_public_path__ + "img/yamaha_mt_07_and_me.9f398822.jpg";